import { Injectable } from '@angular/core';
import { Library } from '../models/library';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

const API_UL = ``;

@Injectable({
  providedIn: 'root'
})
export class LibraryService {
  constructor(private http: HttpClient) {}

  search(query = 'Serene'): Observable<Library[]> {
    return this.http.get<Library[]>(`${environment.apiRoot}libraries?library=${query}`);
  }

  uploadProtocols(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(`${environment.apiRoot}libraries/import-protocols`, formData);
  }
}
